import React, {Component} from 'react';
import {connect} from 'react-redux'

import bindAll from 'lodash.bindall';
import RecordComponent from '../components/evaluate/record/record.jsx';
import {getStudentEvaluationRequest, deleteStudentEvaluationRequest,getClassEvaluationRequest} from "../service/reason";

import Prompt from '../components/prompt/prompt.jsx';
import LogOutPrompt from "../components/prompt/prompt";
import {FILE_URL} from "../util/constants";
import defaultImg from '../img/bee.png';

class RecordContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'deleteRecord',
            'handleScroll',
            'showPrompt',
            'delete',
            'handleImageErrored'
        ]);
        this.state = {
            recordList: [],
            isBottom: false,
            showPrompt:false,
            item:{}
        }
    }

    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll, true);

        getStudentEvaluationRequest(this.props.banji_code, '0', (data) => {
            console.log(data)
            if (data.ret == '1') {

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                }
                this.setState({
                    recordList: list
                });

            } else {

            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleImageErrored(index){
        console.log('加载图片出错')
        var list = this.state.recordList;
        list[index].student_pic = defaultImg;

        this.setState({
            recordList:list
        });
    }

    handleScroll(event) {

        const clientHeight = event.target.clientHeight
        const scrollHeight = event.target.scrollHeight
        const scrollTop = event.target.scrollTop

        var plusHeight = clientHeight + parseInt(scrollTop);
        var isBottom = (plusHeight === scrollHeight)


        if (isBottom) {
            console.log('加载更多')
        } else {
            console.log('没到达底部')
        }

        if (plusHeight == scrollHeight) {
            //getTeacherPingjiaList('12',this.state.recordList.length,(data) => {

            // this.setState({
            //     recordList: this.state.recordList.concat(data.data.log)
            // });

            getStudentEvaluationRequest(this.props.banji_code, this.state.recordList.length, (data) => {
                console.log(data)
                if (data.ret == '1') {
                    var list = data.data;
                    for (let i = 0; i < list.length; i++) {
                        list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                    }
                    this.setState({
                        recordList: this.state.recordList.concat(list)
                    });
                } else {

                }
            });

        }
    }


    handleCancel() {
        this.props.closeSelf();
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    deleteRecord(item) {

        this.setState({
            item:item
        })
        this.showPrompt();

    }

    showPrompt(){
        var show = !this.state.showPrompt;
        this.setState({
            showPrompt:show
        })
    }

    delete(){
        var dongtai_id = this.state.item.dongtai_id;
        var dianzan_type = this.state.item.dianzan_type;
        var student_pid = this.state.item.student_pid;
        var dianzan_code = this.state.item.dianzan_code;
        var class_code = this.props.banji_code;

        deleteStudentEvaluationRequest(dongtai_id,dianzan_type,class_code,student_pid,dianzan_code, (data) => {
            console.log(data);
            if (data.ret === '1') {
                for (let i = 0; i < this.state.recordList.length; i++) {
                    if (this.state.recordList[i].dongtai_id === dongtai_id) {
                        this.state.recordList.splice(i, 1);
                        this.setState({
                            recordList: this.state.recordList
                        });
                    }
                }

                this.setState({
                    showPrompt:false
                })

                if(this.state.recordList.length==0){
                    getStudentEvaluationRequest(this.props.banji_code, '0', (data) => {
                        console.log(data)
                        var list = data.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                        }
                        this.setState({
                            recordList: list
                        });
                    });
                }

                this.showToast('删除成功',1000);
                this.props.deleteFinish();
            }
        });
    }

    render() {

        return (
            <div>
                <RecordComponent
                    recordList={this.state.recordList}
                    onRequestClose={this.props.closeRecord}
                    deleteRecord={this.deleteRecord}
                    handleImageErrored={this.handleImageErrored}
                />
                {this.state.showPrompt?
                    <Prompt
                        label='删除评价'
                        title='是否删除该评价？'
                        onCancel={this.showPrompt}
                        onOk={this.delete}
                    />
                :null}


            </div>

        )
    }


}

RecordContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecordContainer);
